import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["avatarHash", "email", "displayName", "renderName"];
import { Avatar } from 'avatar-components/Avatar';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { getAvatarUrl } from '../avatarQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AvatarViewer = _ref => {
  let {
      avatarHash,
      email,
      displayName,
      renderName
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    gap: 8,
    children: [/*#__PURE__*/_jsx(Avatar, Object.assign({
      displayName: displayName,
      hubSpotUserEmail: email,
      size: "xl",
      src: avatarHash ? getAvatarUrl(avatarHash) : undefined
    }, props)), renderName && displayName]
  });
};
export default AvatarViewer;